var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loading"},[_c('div',{staticClass:"circle",class:_vm.css},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }